import { mergeArrays } from '@utils-clean/array-helpers';
import { IRoute } from './interfaces';
import AcceptOrganisationInvite from 'views/pages/uam/accept-organisation-invite';
import ForgotPassword from 'views/pages/uam/forgot-password';
import InfoScreen from 'views/pages/uam/info-screen';
import Login from 'views/pages/uam/login';
import LoginStep2 from 'views/pages/uam/login-step2';
import ResetPassword from 'views/pages/uam/reset-password';
import VerifyEmailAddress from 'views/pages/uam/verify-email';
import { LoginPaths } from '@config/routes/paths';

const location = {
    state: {
        layout: 'LOGIN',
    },
};

// IMPORTANT - For any new routes, the key and path must be added to paths.tsx and the path prop should be excluded from this file

const LoginRoutes: IRoute[] = mergeArrays(
    LoginPaths,
    [
        {
            exact: true,
            key: 'info',
            component: InfoScreen,
            location,
        },
        {
            exact: true,
            key: 'login',
            component: Login,
            location,
        },
        {
            exact: true,
            key: 'login-2fa-org',
            component: LoginStep2,
            location,
        },
        {
            exact: true,
            key: 'login-2fa',
            component: LoginStep2,
            location,
        },
        {
            key: 'login-organisation',
            component: Login,
            location,
        },
        {
            key: 'password-reset-org',
            component: ResetPassword,
            location,
        },
        {
            key: 'password-reset',
            component: ResetPassword,
            location,
        },
        {
            key: 'forgot-password-admin',
            exact: true,
            component: ForgotPassword,
            location,
        },
        {
            key: 'forgot-password',
            component: ForgotPassword,
            location,
        },
        {
            key: 'accept-org-invite',
            component: AcceptOrganisationInvite,
            location,
        },
        {
            key: 'verify-email',
            component: VerifyEmailAddress,
            location,
        },
    ],
    (item) => item.key,
);

export default LoginRoutes;
